import { FC, useState } from 'react';
import { Container } from '@material-ui/core';
import styled from 'styled-components';
import { getChecklist, groupBySection } from './services/DataService';
import Checklist from './components/Checklist';
import BottomBar from './components/BottomBar';
import Menu from './components/Menu';
import useChecklist from './hooks/useChecklist';

const StyledContainer = styled(Container)`
    display: flex !important;
    height: 100vh !important;
    flex-direction: column !important;
`;

const MainContent = styled.div`
    margin: auto;
    background-color: ${({ theme }) => theme.palette.background.default};
    width: 100%;
`;

const checklistData = getChecklist();
const checklistId = 'checklist';

const App: FC = () => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [filtered, setFiltered] = useState(false);

    const { data, click, reset } = useChecklist(checklistId, checklistData);
    const groupedData = groupBySection(data);

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const onFilterChange = () => {
        setFiltered((current) => !current);
    };

    const resetState = () => {
        reset();
    };

    const openMenu = () => {
        setMenuIsOpen(true);
    };

    return (
        <StyledContainer maxWidth="md" disableGutters>
            <MainContent>
                <Checklist
                    filtered={filtered}
                    data={groupedData}
                    onClick={click}
                />
            </MainContent>
            <BottomBar
                isFilterOn={filtered}
                onFilterChanged={onFilterChange}
                onResetClick={resetState}
                onMenuClick={openMenu}
            />
            <Menu
                handleClose={handleMenuClose}
                isOpen={menuIsOpen}
                items={Object.keys(groupedData).map((section) => (
                    <a href={`#${section}`}>{section}</a>
                ))}
            />
        </StyledContainer>
    );
};

export default App;
